import { useEffect } from "react";
import { App as CapApp } from "@capacitor/app";

import FullScreenMobilePage from "../FullScreenMobilePage/FullScreenMobilePage";
import Button from "../Button/Button";
import ToastMessage from "../ToastMessage/ToastMessage";

import type { PlatformVersionInfo } from "../../connectors/appVersionApi";
import { APP_VERSION_TOAST_CONTAINER_ID } from "../../constants/appVersion";
import { openAppStore } from "../../utils/openAppStore";

import infoIcon from "../../assets/icons/info-light-icon.svg";

import styles from "./SuggestedUpdateScreen.module.scss";

interface Props {
  platformInfo: PlatformVersionInfo | null;
  onDismiss: () => void;
}

const SuggestedUpdateScreen = ({ platformInfo, onDismiss }: Props) => {
  const { content, footer } = styles;

  // Hardware back on Android = "Más tarde". Mirrors the user's expectation
  // that back behaves like dismissing a non-blocking modal.
  useEffect(() => {
    let listener: { remove: () => void } | undefined;
    let cancelled = false;

    void (async () => {
      const handle = await CapApp.addListener("backButton", () => {
        onDismiss();
      });
      if (cancelled) {
        handle?.remove?.();
        return;
      }
      listener = handle;
    })();

    return () => {
      cancelled = true;
      listener?.remove?.();
    };
  }, [onDismiss]);

  return (
    <>
      <FullScreenMobilePage
        noLogo
        footerContent={
          <section className={footer}>
            <Button
              variant="primary"
              text="Actualizar"
              onPress={() => void openAppStore(platformInfo)}
            />
            <Button
              variant="secondary"
              text="Más tarde"
              onPress={onDismiss}
            />
          </section>
        }
      >
        <div className={content}>
          <img src={infoIcon} alt="Ícono de información" />
          <h1>Nueva versión disponible</h1>
          <p>Actualizá la app para acceder a las últimas mejoras y funciones.</p>
        </div>
      </FullScreenMobilePage>
      <ToastMessage messageId={APP_VERSION_TOAST_CONTAINER_ID} position="top-center" />
    </>
  );
};

export default SuggestedUpdateScreen;
